<template>
    <div v-if="products.length > 1">
        <div class="pt-10" v-for="attribute in attributes" :key="attribute.id">
            <h3>{{ attribute.name }}</h3>

            <v-row>
                <v-col cols="12" sm="6" md="4" xl="3" v-for="product in products" :key="product.id">
                    <div class="subtitle-1 text--disabled py-3">{{ product.productName }}</div>
                    <div v-if="product.data[attribute.system_name]">
                        <div v-if="!product.data[attribute.system_name].has_numeric_attributes">
                            <template
                                v-if="!product.data[attribute.system_name].items.parents.length"
                                v-for="(item, idx) in product.data[attribute.system_name].items.values"
                            >
                                <component
                                    :key="item.value"
                                    :is="getTag(item.system_name)"
                                    :to="getLink(product.data[attribute.system_name].system_name, item.system_name)"
                                    :class="{'text-underline': item.system_name}"
                                >
                                    {{ item.value.toLowerCase() }}
                                </component>
                                {{ getLastSymbol(product.data[attribute.system_name].items.values, idx) }}
                            </template>
                            <template>
                                <v-simple-table
                                    dense
                                    class="table-transparency"
                                >
                                    <template v-slot:default>
                                        <tbody>
                                        <template v-for="(parent, idx) in product.data[attribute.system_name].items.parents">
                                            <tr>
                                                <td class="pl-0 table-col"><span class="font-weight-medium">{{parent.value.toLowerCase()}}</span></td>
                                            </tr>
                                            <tr>
                                                <td class="pl-0 table-col half-width">
                                                    <template
                                                        v-for="(item, idx) in getValuesByParentId(product.data[attribute.system_name].items.values, parent.value_id)"
                                                    >
                                                        <component
                                                            :key="item.parent_id + item.value"
                                                            :is="getTag(item.system_name)"
                                                            :to="getLink(product.data[attribute.system_name].system_name, item.system_name)"
                                                            :class="{'text-underline': item.system_name}"
                                                        >
                                                            {{ item.value.toLowerCase() }}
                                                        </component>
                                                        {{ getLastSymbol(getValuesByParentId(product.data[attribute.system_name].items.values, parent.value_id), idx) }}
                                                    </template>
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </template>
                        </div>
                        <div v-if="product.data[attribute.system_name].has_numeric_attributes">
                            <v-simple-table
                                dense
                                class="table-transparency"
                            >
                                <template v-slot:default>
                                    <tbody>
                                    <tr
                                        v-for="(item, idx) in product.data[attribute.system_name].items.values"
                                        :key="idx"
                                        class="table-row"
                                    >
                                        <td class="pl-0 table-col half-with">
                                            <component
                                                class="numeric-values"
                                                :key="item.parent_id + item.value"
                                                :is="getTag(item.system_name)"
                                                :to="getLink(product.data[attribute.system_name].system_name, item.system_name)"
                                                :class="{'text-underline': item.system_name}"
                                            >
                                                {{ item.value.name.toLowerCase() }}
                                            </component>
                                        </td>
                                        <td class="table-col half-width"><span class="numeric-values">{{ item.value.numeric }}</span></td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-divider></v-divider>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProductsParams',
        props: {
            products: {
                required: true,
                type: Array,
            },
        },
        computed: {
            attributes() {
                return this.products
                    .flatMap(product => {
                        return Object.values(product.data).map(item => {
                            return {
                                id: item.attribute_id,
                                name: item.name,
                                system_name: item.system_name,
                            }
                        });
                    })
                    .sort((attr1, attr2) => attr1.id - attr2.id)
                    .reduce((result, current) => {
                        if (!result.some(item => item.id === current.id)) {
                            result.push(current);
                        }

                        return result;
                    }, []);
            },
        },
        methods: {
            getValues(data) {
                if (!data) {
                    return '-';
                }

                const { parents, values } = data.items;

                if (!parents.length) {

                    return values.map(item => {
                        return !data.has_numeric_attributes ? item.value : `${item.value.name} - ${item.value.numeric}`
                    }).join(', ');
                }

                return parents.map(parent => {
                    const subValues = values
                        .filter(item => item.parent_id === parent.value_id)
                        .map(item => item.value.toLowerCase())
                        .join(', ');

                    return `${ parent.value } (${ subValues })`
                }).join(', ');
            },
            getTag(systemName) {
                return systemName ? 'router-link' : 'span';
            },
            getLink(parentSystemName, systemName) {
                return systemName ? `/products/attribute/${parentSystemName}/${systemName}` : null;
            },
            getLastSymbol(array, idx) {
                return idx !== array.length - 1 ? ', ' : '';
            },
            getValuesByParentId(values, id) {
                return values.filter(value => value.parent_id === id);
            },
        },
    }
</script>

<style scoped>
.half-width {
    width: 35%;
}
.table-transparency {
    background-color: rgba(0,0,0,0);
}
</style>
